import { render, staticRenderFns } from "./BankaHesabiList.vue?vue&type=template&id=d4dd5234"
import script from "./BankaHesabiList.vue?vue&type=script&lang=ts"
export * from "./BankaHesabiList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports